import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { createRoot } from "react-dom/client";
import { useSelector } from "react-redux";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { Howl, Howler } from "howler";
import jacksrbetterJson from "../jrbjson.json";
import Joker from "../../../../../../library/Card/joker";
import resultCardsCss from "../../../../../pokerCssCards";
// import resultCards from "../resultCards";
// import reaveldealer_cards_sound from "../../../../../../assets/sounds/dealercards_reavel.mp3";
// import emtyCard from "../../../../../../assets/games/jacksorbetter/Asset 1.svg";
import emtyCard from "../../../../../../assets/games/jacksorbetter/emtyCard.svg";
import tensorbetterEmtyCard from "../../../../../../assets/games/jacksorbetter/tensrbetter2.svg";
import deucesWildEmtyCard from "../../../../../../assets/games/jacksorbetter/deucesEmetyCard.svg";
import jokerPokerEmtyCard from "../../../../../../assets/games/jacksorbetter/jokerPokerEmetyCard.svg";
import ReactDOM from 'react-dom';

// import deucesWildHeart from '../../../../../../assets/games/jacksorbetter/dw2h.svg';
// import deucesWildDiamond from '../../../../../../assets/games/jacksorbetter/dw2d.svg';
// import deucesWildSpade from '../../../../../../assets/games/jacksorbetter/dw2s.svg';
// import deucesWildClub from '../../../../../../assets/games/jacksorbetter/dw2c.svg';

// import jokerpokerHeart from '../../../../../../assets/games/jacksorbetter/jpjh.svg';
// import jokerpokerDiamond from '../../../../../../assets/games/jacksorbetter/jpjd.svg';
// import jokerpokerSpade from '../../../../../../assets/games/jacksorbetter/jpjs.svg';
// import jokerpokerClub from '../../../../../../assets/games/jacksorbetter/jpjc.svg';

import "./index.css"
import Howlersounds from "../../../../Utillitys/howlersounds";


// const deucesWildCardsArray = [
//     { src: deucesWildHeart },
//     { src: deucesWildDiamond },
//     { src: deucesWildSpade },
//     { src: deucesWildClub },
// ]
// const jokerpokerCardsArray = [
//     { src: jokerpokerHeart },
//     { src: jokerpokerDiamond },
//     { src: jokerpokerSpade },
//     { src: jokerpokerClub },
// ]
const CardsContainer = forwardRef((props, ref) => {
    const language = useSelector((state) => state.languageObjs.languageObj)

    const [classVaribles, setclassVaribles] = useState({});
    const [flipSound, setFlipSound] = useState({ betSound: null, isPlayingFlipSound: null });

    const reaveldealer_cards = useRef(null);
    const backFaceCard = useRef(null);
    const howlerSoundsRef = useRef(null);
    const { contextSafe } = useGSAP()

    // let initializeCardFlipSound = () => {
    //     try {
    //         let betSound = new Howl({
    //             src: [reaveldealer_cards_sound],
    //             html5: true,
    //             preload: true,
    //             onplayerror: () => {     // Handle play errors
    //                 betSound.once('unlock', () => betSound.play());
    //             }
    //         });

    //         setFlipSound((prev) => ({ ...prev, betSound, isPlayingFlipSound: false }));
    //         return betSound;
    //     } catch (error) {
    //         console.error("Error initializing bet sound:", error);
    //         return null;
    //     }
    // };


    useEffect(() => {
        switch (Number(props.gameId)) {
            case 30:
                backFaceCard.current = emtyCard;
                break;
            case 35:
                backFaceCard.current = deucesWildEmtyCard;
                break;
            case 36:
                backFaceCard.current = jokerPokerEmtyCard;
                break;
            case 40:
                backFaceCard.current = tensorbetterEmtyCard;
                break;
            default:
                return null

        }
        gsap.ticker.lagSmoothing(0);
        // reaveldealer_cards.current = initializeCardFlipSound();
        const interval = setInterval(() => gsap.ticker.tick(), 500);
        // console.log(flipSound.betSound)
        window.addEventListener("resize", handleResize);
        handleOrientationChange()
        return () => {
            reaveldealer_cards.current.pause();
            window.removeEventListener("resize", handleResize);
            clearInterval(interval);
        }
        // }, [flipSound.isPlayingFlipSound])
    }, [])

    const { cardDetails, clickOncardToHoldorUnhold, isSoundOn } = props;
    // console.log(cardDetails);
    const { id, src, value, hold } = cardDetails

    const handleResize = () => {
        handleOrientationChange()
    }

    // useEffect(() => {
    const handleOrientationChange = () => {
        const isActiveWindowsMode = (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
            (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))

        // Determine if the device is in portrait or landscape mode
        const isActivePortraitMode = window.innerHeight > window.innerWidth;
        const isActiveLandscapeMode = window.innerWidth > window.innerHeight;
        if (isActiveWindowsMode) {
            setclassVaribles({
                liContainer: jacksrbetterJson.liContainer,
                cardImage: jacksrbetterJson.cardImage,
                holdSpan: jacksrbetterJson.holdSpan

            })

        } else if (isActivePortraitMode) {
            setclassVaribles({
                liContainer: jacksrbetterJson.liContainerPrt,
                cardImage: jacksrbetterJson.cardImage,
                holdSpan: jacksrbetterJson.holdSpan

            })

        } else {
            setclassVaribles({
                liContainer: jacksrbetterJson.liContainerLnd,
                cardImage: jacksrbetterJson.cardImage,
                holdSpan: jacksrbetterJson.holdSpan

            })

        }



        // }, []);
    }




    // let playRemainingSounds = (chipSound) => {
    //     let currentSound = chipSound;
    //     if (isSoundOn) {
    //         // if (!chipSound || flipSound.isPlayingFlipSound) {
    //         if (!reaveldealer_cards.current) {
    //             reaveldealer_cards.current = initializeCardFlipSound();
    //         }
    //         reaveldealer_cards.current.play();

    //         setFlipSound({
    //             currentSound,
    //             isPlayingFlipSound: true,
    //         });

    //     }

    // };


    // useImperativeHandle(ref, contextSafe(() => ({
    useImperativeHandle(ref, () => ({

        resetCardsOnReload(res) {

            let cardLength = res.cards.length;

            let t1 = gsap.timeline();
            t1.clear(); // Clears all previous animations
            // setflipbackgroundImg();

            switch (Number(props.gameId)) {
                case 35:
                    // '2H', '2D', '2C', '2S', 'JC'
                    for (let i = 0; i < cardLength; i++) {
                        const cardElement = document.getElementById(`jrb${i}`);

                        const cardTopSuit = document.getElementById(`${i}-card-top-suit`);
                        const cardBottomSuit = document.getElementById(`${i}-card-bottom-suit`);
                        const cardRank = document.getElementById(`${i}-card-rank`);
                        const wildJokerCardText = document.getElementById(`${i}-wild-joker-card-text`);

                        const cardValue = res.cards[i];
                        const wildCardIndex = ["2H", "2D", "2S", "2C"].indexOf(cardValue);
                        if (wildCardIndex !== -1) {
                            if (cardElement) {
                                // if (cardElement && deucesWildCardsArray[wildCardIndex]) {
                                for (let j = 0; j < resultCardsCss.length; j++) {
                                    if (resultCardsCss[j].rsc_val === res.cards[i]) {
                                        if (cardElement && resultCardsCss[j].src) {
                                            cardTopSuit.textContent = resultCardsCss[j].src;
                                            cardBottomSuit.textContent = resultCardsCss[j].src;
                                            cardRank.textContent = resultCardsCss[j].card_rank;
                                            wildJokerCardText.textContent = "Wild";

                                            cardTopSuit.setAttribute("datasuit", resultCardsCss[j].src);
                                            cardBottomSuit.setAttribute("datasuit", resultCardsCss[j].src);
                                            cardRank.setAttribute("datasuit", resultCardsCss[j].src);
                                        }
                                    }
                                }

                            }
                        } else {
                            for (let j = 0; j < resultCardsCss.length; j++) {
                                if (resultCardsCss[j].rsc_val === res.cards[i]) {
                                    if (cardElement && resultCardsCss[j].src) {
                                        cardTopSuit.textContent = resultCardsCss[j].src;
                                        cardBottomSuit.textContent = resultCardsCss[j].src;
                                        cardRank.textContent = resultCardsCss[j].card_rank;
                                        wildJokerCardText.textContent = "";

                                        cardTopSuit.setAttribute("datasuit", resultCardsCss[j].src);
                                        cardBottomSuit.setAttribute("datasuit", resultCardsCss[j].src);
                                        cardRank.setAttribute("datasuit", resultCardsCss[j].src);
                                        cardRank.setAttribute("textContext", resultCardsCss[j].card_rank);


                                    }
                                }
                            }
                        }
                    }
                    break;
                case 36:
                    // '2H', '2D', '2C', '2S', 'JC'
                    for (let i = 0; i < cardLength; i++) {
                        const cardElement = document.getElementById(`jrb${i}`);

                        const cardTopSuit = document.getElementById(`${i}-card-top-suit`);
                        const cardBottomSuit = document.getElementById(`${i}-card-bottom-suit`);
                        const cardRank = document.getElementById(`${i}-card-rank`);
                        const wildJokerCardText = document.getElementById(`${i}-wild-joker-card-text`);

                        const cardValue = res.cards[i];
                        // const jokerpokerCardIndex = ["JH", "JD", "JS", "JC"].indexOf(cardValue);
                        const jokerpokerCardIndex = ["JK"].indexOf(cardValue);
                        if (jokerpokerCardIndex !== -1) {
                            for (let j = 0; j < resultCardsCss.length; j++) {
                                if ("JK" === res.cards[i]) {

                                    if (cardElement) {
                                        const jokerElement = document.createElement("div");
                                        jokerElement.classList.add("jokerCardJP")
                                        cardTopSuit.innerHTML = ""
                                        cardTopSuit.appendChild(jokerElement);

                                        // use createRoot once
                                        const root = createRoot(jokerElement);
                                        root.render(<Joker />);
                                        //    const root = createRoot(cardTopSuit);
                                        //  root.render(<Joker />);
                                        // cardBottomSuit.innerHTML = <Joker></Joker>;
                                        cardRank.textContent = ""
                                        wildJokerCardText.classList.add("jokerText")
                                        // wildJokerCardText.textContent = "JOKER";

                                        cardTopSuit.setAttribute("datasuit", "🤡");
                                        cardBottomSuit.setAttribute("datasuit", "🤡");
                                        cardRank.setAttribute("datasuit", "🤡");

                                    }
                                }
                            }
                        } else {
                            for (let j = 0; j < resultCardsCss.length; j++) {
                                if (resultCardsCss[j].rsc_val === res.cards[i]) {
                                    if (cardElement && resultCardsCss[j].src) {

                                        cardTopSuit.textContent = resultCardsCss[j].src;
                                        cardBottomSuit.textContent = resultCardsCss[j].src;
                                        cardRank.textContent = resultCardsCss[j].card_rank;
                                        wildJokerCardText.textContent = "";

                                        cardTopSuit.setAttribute("datasuit", resultCardsCss[j].src);
                                        cardBottomSuit.setAttribute("datasuit", resultCardsCss[j].src);
                                        cardRank.setAttribute("datasuit", resultCardsCss[j].src);
                                        cardRank.setAttribute("textContext", resultCardsCss[j].card_rank);

                                    }
                                }
                            }
                        }
                    }
                    break;
                default:
                    for (let i = 0; i < cardLength; i++) {
                        for (let j = 0; j < resultCardsCss.length; j++) {
                            if (resultCardsCss[j].rsc_val === res.cards[i]) {
                                const cardElement = document.getElementById(`jrb${i}`);

                                const cardTopSuit = document.getElementById(`${i}-card-top-suit`);
                                const cardBottomSuit = document.getElementById(`${i}-card-bottom-suit`);
                                const cardRank = document.getElementById(`${i}-card-rank`);
                                const wildJokerCardText = document.getElementById(`${i}-wild-joker-card-text`);

                                if (cardTopSuit && resultCardsCss[j].src) {
                                    cardTopSuit.textContent = resultCardsCss[j].src;
                                    cardBottomSuit.textContent = resultCardsCss[j].src;
                                    cardRank.textContent = resultCardsCss[j].card_rank;
                                    wildJokerCardText.textContent = "";

                                    cardTopSuit.setAttribute("datasuit", resultCardsCss[j].src);
                                    cardBottomSuit.setAttribute("datasuit", resultCardsCss[j].src);
                                    cardRank.setAttribute("datasuit", resultCardsCss[j].src);
                                    cardRank.setAttribute("textContext", resultCardsCss[j].card_rank);
                                }
                            }
                        }
                    }

                    break;
            }

        }
        ,



        dealBetResultRes(res) {
            // console.log(res);
            let cardLength = res.cards.length;
            // console.log("cardLength", cardLength);
            // console.log("resultCardsCss.length", resultCardsCss, resultCardsCss.length);
            let dealerFirstCards = []
            switch (Number(props.gameId)) {
                case 35:
                    // '2H', '2D', '2C', '2S', 'JC'
                    for (let i = 0; i < cardLength; i++) {
                        const wildJokerCardText = document.getElementById(`${i}-wild-joker-card-text`);
                        const cardValue = res.cards[i];
                        const wildCardIndex = ["2H", "2D", "2S", "2C"].indexOf(cardValue);
                        if (wildCardIndex !== -1) {
                            const matchedCard = resultCardsCss.find(card => card.rsc_val === cardValue);
                            setTimeout(() => {
                                if (wildJokerCardText) {
                                    wildJokerCardText.textContent = "Wild";
                                }
                            }, 700 + i * 300)
                            dealerFirstCards.push(matchedCard);
                            // dealerFirstCards.push(deucesWildCardsArray[wildCardIndex]);
                        } else {
                            wildJokerCardText.textContent = "";
                            const matchedCard = resultCardsCss.find(card => card.rsc_val === cardValue);
                            dealerFirstCards.push(matchedCard);
                        }
                    }

                    break;
                case 36:
                    // '2H', '2D', '2C', '2S', 'JC'
                    for (let i = 0; i < cardLength; i++) {
                        const cardValue = res.cards[i];
                        const wildJokerCardText = document.getElementById(`${i}-wild-joker-card-text`);
                        // const jokerpokerCardIndex = ["JH", "JD", "JS", "JC"].indexOf(cardValue);
                        const jokerpokerCardIndex = ["JK"].indexOf(cardValue);
                        if (jokerpokerCardIndex !== -1) {
                            setTimeout(() => {
                                // wildJokerCardText.textContent = "Joker";
                            }, 700 + i * 250)
                            // const matchedCard = resultCardsCss.find(card => card.rsc_val === cardValue);
                            dealerFirstCards.push({ src: "🤡", card_rank: "JK", rsc_val: 'JK' });
                            // dealerFirstCards.push(jokerpokerCardsArray[jokerpokerCardIndex]);
                        } else {
                            const matchedCard = resultCardsCss.find(card => card.rsc_val === cardValue);
                            dealerFirstCards.push(matchedCard);
                            wildJokerCardText.textContent = "";
                        }
                    }

                    break;
                default:

                    for (let i = 0; i < cardLength; i++) {
                        const cardValue = res.cards[i];
                        const matchedCard = resultCardsCss.find(card => card.rsc_val === cardValue);
                        dealerFirstCards.push(matchedCard);
                    }
                    break;
            }

            let t1 = gsap.timeline();
            t1.clear(); // Clear previous animations
            console.log("dealerFirstCards :  ", dealerFirstCards)
            setTimeout(() => {

                for (let i = 0; i < cardLength; i++) {
                    const cardElement = document.getElementById(`jrb${i}`);
                    const cardTopSuit = document.getElementById(`${i}-card-top-suit`);
                    const cardBottomSuit = document.getElementById(`${i}-card-bottom-suit`);
                    const cardRank = document.getElementById(`${i}-card-rank`);
                    const wildJokerCardText = document.getElementById(`${i}-wild-joker-card-text`);

                    if (cardElement && dealerFirstCards[i] && dealerFirstCards[i].src && dealerFirstCards[i].card_rank !== "JK") {
                        // if (cardTopSuit && dealerFirstCards[i] && dealerFirstCards[i].src) {
                        console.log("dealerFirstCards :  ", dealerFirstCards)
                        t1.to(cardElement, {
                            rotateY: 90,
                            ease: "power3.inOut",
                            duration: 0.15,
                            autoAlpha: 1,
                            // delay: i * 0.05, // Stagger flips by index
                            // delay: 2 * 0.05, // Stagger flips by index
                            onStart: () => {
                                howlerSoundsRef.current?.playSound("reavelDealerCards")
                            },
                            onComplete: () => {
                                clearGameTitle(i);
                                if (cardTopSuit) {
                                    cardTopSuit.textContent = dealerFirstCards[i].src;
                                    cardBottomSuit.textContent = dealerFirstCards[i].src;
                                    cardRank.textContent = dealerFirstCards[i].card_rank;


                                    cardTopSuit.datasuit = dealerFirstCards[i].src;
                                    cardBottomSuit.datasuit = dealerFirstCards[i].src;
                                    cardRank.datasuit = dealerFirstCards[i].src;
                                }

                            }
                        })
                            // .set(cardElement, { attr: { src: dealerFirstCards[i].src } }) // Set the new card image mid-flip
                            .set(cardTopSuit, { attr: { textContent: dealerFirstCards[i].src, datasuit: dealerFirstCards[i].src } }) // Set the new card image mid-flip
                            .set(cardBottomSuit, { attr: { textContent: dealerFirstCards[i].src, datasuit: dealerFirstCards[i].src } }) // Set the new card image mid-flip
                            .set(cardRank, { attr: { textContent: dealerFirstCards[i].card_rank, datasuit: dealerFirstCards[i].src } }) // Set the new card image mid-flip

                            .to(cardElement, {
                                rotateY: 0,
                                ease: "power3.inOut",
                                // duration: 0.15,
                                duration: 0.1,
                                autoAlpha: 1,
                                onComplete: () => {
                                    // if (res.autoHoldCards && res.autoHoldCards[i]) {
                                    //     setTimeout(() => {   
                                    //         clickOncardToHoldorUnhold(i);
                                    //     }, 200);
                                    //     // console.log(res.autoHoldCards[i], i);
                                    // }
                                }
                            }, `+=0.1`);
                    }
                    else if (cardElement && dealerFirstCards[i] && dealerFirstCards[i].src && dealerFirstCards[i].card_rank === "JK") {
                        // if (cardTopSuit && dealerFirstCards[i] && dealerFirstCards[i].src) {
                        console.log("dealerFirstCards :  ", dealerFirstCards)
                        t1.to(cardElement, {
                            rotateY: 90,
                            ease: "power3.inOut",
                            duration: 0.15,
                            autoAlpha: 1,
                            // delay: i * 0.05, // Stagger flips by index
                            // delay: 2 * 0.05, // Stagger flips by index
                            onStart: () => {
                                howlerSoundsRef.current?.playSound("reavelDealerCards")
                            },
                            onComplete: () => {
                                clearGameTitle(i);
                                if (cardTopSuit && dealerFirstCards[i].card_rank === "JK") {
                                    const jokerElement = document.createElement("div");
                                    jokerElement.classList.add("jokerCardJP")
                                    cardTopSuit.innerHTML = ""
                                    cardTopSuit.appendChild(jokerElement);

                                    // use createRoot once
                                    const root = createRoot(jokerElement);
                                    root.render(<Joker />);
                                    //    const root = createRoot(cardTopSuit);
                                    //  root.render(<Joker />);
                                    // cardBottomSuit.innerHTML = <Joker></Joker>;
                                    cardRank.textContent = ""
                                    wildJokerCardText.classList.add("jokerText")
                                }

                            }
                        })
                            .to(cardElement, {
                                rotateY: 0,
                                ease: "power3.inOut",
                                // duration: 0.15,
                                duration: 0.1,
                                autoAlpha: 1,
                                onComplete: () => {
                                    // if (res.autoHoldCards && res.autoHoldCards[i]) {
                                    //     setTimeout(() => {   
                                    //         clickOncardToHoldorUnhold(i);
                                    //     }, 200);
                                    //     // console.log(res.autoHoldCards[i], i);
                                    // }
                                }
                            }, `+=0.1`);
                    }

                }

                setTimeout(() => {
                    for (let i = 0; i < cardLength; i++) {
                        if (res.autoHoldCards && res.autoHoldCards[i]) {
                            clickOncardToHoldorUnhold(i);
                        }

                    }
                }, 2000)

                // }, 1000);
            }, 500);
        }
        ,

        drawUnselectedCards(drawResponse, dealerResponse, etyCard, jacksorbettercards) {
            let dealerCards = dealerResponse.cards;
            let drawCards = drawResponse.cards;

            console.log("dealResponse ", dealerResponse, "drawResponse ", drawResponse);

            let cardLength = dealerResponse?.cards?.length;





            let dealerFirstCards = []

            switch (Number(props.gameId)) {
                case 35:
                    // '2H', '2D', '2C', '2S', 'JC'
                    for (let i = 0; i < cardLength; i++) {
                        const cardTopSuit = document.getElementById(`${i}-card-top-suit`);
                        const cardBottomSuit = document.getElementById(`${i}-card-bottom-suit`);
                        const cardRank = document.getElementById(`${i}-card-rank`);
                        const wildJokerCardText = document.getElementById(`${i}-wild-joker-card-text`);
                        if (dealerCards[i] !== drawCards[i] && jacksorbettercards[i].hold === false) {
                            // const cardElement = document.getElementById(`jrb${i}`);
                            cardTopSuit.textContent = "";
                            cardBottomSuit.textContent = "";
                            cardRank.textContent = "";
                            wildJokerCardText.textContent = "";

                            cardTopSuit.datasuit = "";
                            cardBottomSuit.datasuit = "";
                            cardRank.datasuit = "";

                            const cardValue = drawCards[i];
                            const wildCardIndex = ["2H", "2D", "2S", "2C"].indexOf(cardValue);
                            if (wildCardIndex !== -1) {
                                // dealerFirstCards[i] = deucesWildCardsArray[wildCardIndex];
                                setTimeout(() => {
                                    wildJokerCardText.textContent = "Wild";
                                }, 700 + i * 300)
                                const matchedCard = resultCardsCss.find(card => card.rsc_val === cardValue);
                                dealerFirstCards[i] = matchedCard;
                            } else {
                                const matchedCard = resultCardsCss.find(card => card.rsc_val === cardValue);
                                dealerFirstCards[i] = matchedCard;
                                wildJokerCardText.textContent = "";
                            }

                        }
                    }

                    break;
                case 36:
                    // '2H', '2D', '2C', '2S', 'JC'
                    for (let i = 0; i < cardLength; i++) {
                        const cardTopSuit = document.getElementById(`${i}-card-top-suit`);
                        const cardBottomSuit = document.getElementById(`${i}-card-bottom-suit`);
                        const cardRank = document.getElementById(`${i}-card-rank`);
                        const wildJokerCardText = document.getElementById(`${i}-wild-joker-card-text`);
                        if (dealerCards[i] !== drawCards[i] && jacksorbettercards[i].hold === false) {
                            cardTopSuit.textContent = "";
                            cardBottomSuit.textContent = "";
                            cardRank.textContent = "";
                            wildJokerCardText.textContent = "";

                            cardTopSuit.datasuit = "";
                            cardBottomSuit.datasuit = "";
                            cardRank.datasuit = "";
                            // const cardElement = document.getElementById(`jrb${i}`);
                            const cardValue = drawCards[i];
                            // const jokerpokerCardIndex = ["JH", "JD", "JS", "JC"].indexOf(cardValue);
                            const jokerpokerCardIndex = ["JK"].indexOf(cardValue);
                            if (jokerpokerCardIndex !== -1) {
                                const matchedCard = resultCardsCss.find(card => card.rsc_val === cardValue);
                                // dealerFirstCards[i] = matchedCard;
                                dealerFirstCards[i] = { src: "🤡", card_rank: "JK", rsc_val: 'JK' };
                                setTimeout(() => {
                                    // wildJokerCardText.textContent = "Joker";
                                }, 700 + i * 250)
                                // dealerFirstCards[i] = jokerpokerCardsArray[jokerpokerCardIndex];
                            } else {
                                const matchedCard = resultCardsCss.find(card => card.rsc_val === cardValue);
                                dealerFirstCards[i] = matchedCard;
                                wildJokerCardText.textContent = "";
                            }
                        }
                    }

                    break;
                default:
                    for (let i = 0; i < cardLength; i++) {
                        if (dealerCards[i] !== drawCards[i] && jacksorbettercards[i].hold === false) {
                            const cardValue = drawCards[i];
                            const matchedCard = resultCardsCss.find(card => card.rsc_val === cardValue);
                            dealerFirstCards[i] = matchedCard;
                            const cardElement = document.getElementById(`jrb${i}`);


                            const cardTopSuit = document.getElementById(`${i}-card-top-suit`);
                            const cardBottomSuit = document.getElementById(`${i}-card-bottom-suit`);
                            const cardRank = document.getElementById(`${i}-card-rank`);
                            const wildJokerCardText = document.getElementById(`${i}-wild-joker-card-text`);

                            if (cardTopSuit) {
                                cardTopSuit.textContent = "";
                                cardBottomSuit.textContent = "";
                                cardRank.textContent = "";
                                wildJokerCardText.textContent = "";

                                cardTopSuit.datasuit = "";
                                cardBottomSuit.datasuit = "";
                                cardRank.datasuit = "";
                            }

                            // cardElement.src = backFaceCard.current;
                        }
                    }

                    break;
            }

            let t1 = gsap.timeline();
            t1.clear(); // Clears all previous animations
            setTimeout(() => {

                console.log(dealerFirstCards)
                if (dealerResponse && drawResponse) {
                    for (let i = 0; i < cardLength; i++) {
                        if (dealerCards[i] !== drawCards[i] && jacksorbettercards[i].hold === false) {
                            const cardElement = document.getElementById(`jrb${i}`);

                            const cardTopSuit = document.getElementById(`${i}-card-top-suit`);
                            const cardBottomSuit = document.getElementById(`${i}-card-bottom-suit`);
                            const cardRank = document.getElementById(`${i}-card-rank`);
                            const wildJokerCardText = document.getElementById(`${i}-wild-joker-card-text`);
                            // cardElement.src = backFaceCard.current;
                            if (cardElement && dealerFirstCards[i] && dealerFirstCards[i].src && dealerFirstCards[i].card_rank !== "JK") {
                                t1.to(cardElement, {
                                    rotateY: 90,
                                    ease: "power3.inOut",
                                    duration: 0.15,
                                    autoAlpha: 1,
                                    // delay: i * 0.05, // Stagger flips by index
                                    // delay: 2 * 0.05, // Stagger flips by index
                                    onStart: () => {
                                        howlerSoundsRef.current?.playSound("reavelDealerCards")
                                    },
                                    onComplete: () => {
                                        clearGameTitle(i);

                                        if (cardTopSuit && dealerFirstCards[i].card_rank !== "JK") {
                                            cardTopSuit.textContent = dealerFirstCards[i].src;
                                            cardBottomSuit.textContent = dealerFirstCards[i].src;
                                            cardRank.textContent = dealerFirstCards[i].card_rank;

                                            cardTopSuit.datasuit = dealerFirstCards[i].src;
                                            cardBottomSuit.datasuit = dealerFirstCards[i].src;
                                            cardRank.datasuit = dealerFirstCards[i].src;
                                        }
                                    }
                                })
                                    .set(cardTopSuit, { attr: { textContent: dealerFirstCards[i].src, datasuit: dealerFirstCards[i].src } }) // Set the new card image mid-flip
                                    .set(cardBottomSuit, { attr: { textContent: dealerFirstCards[i].src, datasuit: dealerFirstCards[i].src } }) // Set the new card image mid-flip
                                    .set(cardRank, { attr: { textContent: dealerFirstCards[i].card_rank, datasuit: dealerFirstCards[i].src } }) // Set the new card image mid-flip
                                    .to(cardElement, {
                                        rotateY: 0,
                                        ease: "power3.inOut",
                                        // duration: 0.15,
                                        duration: 0.1,
                                        autoAlpha: 1,

                                    }, `+=0.1`);
                            }
                            else if (cardElement && dealerFirstCards[i] && dealerFirstCards[i].card_rank === "JK") {
                                t1.to(cardElement, {
                                    rotateY: 90,
                                    ease: "power3.inOut",
                                    duration: 0.15,
                                    autoAlpha: 1,
                                    // delay: i * 0.05, // Stagger flips by index
                                    // delay: 2 * 0.05, // Stagger flips by index
                                    onStart: () => {
                                        howlerSoundsRef.current?.playSound("reavelDealerCards")
                                    },
                                    onComplete: () => {
                                        clearGameTitle(i);

                                        if (cardTopSuit && dealerFirstCards[i].card_rank === "JK") {
                                            const jokerElement = document.createElement("div");
                                            jokerElement.classList.add("jokerCardJP")
                                            cardTopSuit.innerHTML = ""
                                            cardTopSuit.appendChild(jokerElement);

                                            // use createRoot once
                                            const root = createRoot(jokerElement);
                                            root.render(<Joker />);
                                            //    const root = createRoot(cardTopSuit);
                                            //  root.render(<Joker />);
                                            // cardBottomSuit.innerHTML = <Joker></Joker>;
                                            cardRank.textContent = ""
                                            wildJokerCardText.classList.add("jokerText")
                                        }
                                    }
                                }).to(cardElement, {
                                    rotateY: 0,
                                    ease: "power3.inOut",
                                    // duration: 0.15,
                                    duration: 0.1,
                                    autoAlpha: 1,

                                }, `+=0.1`);



                                // cardTopSuit.textContent = dealerFirstCards[i].src;
                                // cardBottomSuit.textContent = dealerFirstCards[i].src;
                                // cardRank.textContent = dealerFirstCards[i].card_rank;

                                // cardTopSuit.datasuit = dealerFirstCards[i].src;
                                // cardBottomSuit.datasuit = dealerFirstCards[i].src;
                                // cardRank.datasuit = dealerFirstCards[i].src;
                            }


                        }

                    }

                }
                // },1000)
            }, 500)

        },



        restartTheGame(intialCards) {

            let cardLength = intialCards.length;
            let t2 = gsap.timeline();
            // console.log("cardLength", cardLength)
            for (let i = 0; i < cardLength; i++) {
                const cardElement = document.getElementById(`jrb${i}`);

                setflipbackgroundImg(i);
                const cardTopSuit = document.getElementById(`${i}-card-top-suit`);
                const cardBottomSuit = document.getElementById(`${i}-card-bottom-suit`);
                const cardRank = document.getElementById(`${i}-card-rank`);
                const wildJokerCardText = document.getElementById(`${i}-wild-joker-card-text`);
                const backCardText = document.getElementById(`${i}-back-card-text`);


                if (cardTopSuit) {
                    cardTopSuit.textContent = "";
                    cardBottomSuit.textContent = "";
                    cardRank.textContent = "";
                    wildJokerCardText.textContent = "";

                    cardTopSuit.datasuit = "";
                    cardBottomSuit.datasuit = "";
                    cardRank.datasuit = "";
                }



                // cardElement.src = backFaceCard.current;
            }

        },

        setflipbackgroundImgParent(i) {
            setflipbackgroundImg(i);
        }



    }))
    // )

    const setflipbackgroundImg = (i) => {

        const cardElement = document.getElementById(`jrb${i}`);

        const cardTopSuit = document.getElementById(`${i}-card-top-suit`);
        const cardBottomSuit = document.getElementById(`${i}-card-bottom-suit`);
        const cardRank = document.getElementById(`${i}-card-rank`);
        const wildJokerCardText = document.getElementById(`${i}-wild-joker-card-text`);
        const backCardText = document.getElementById(`${i}-back-card-text`);


        if (cardTopSuit) {
            cardTopSuit.textContent = "";
            cardBottomSuit.textContent = "";
            cardRank.textContent = "";
            wildJokerCardText.textContent = "";

            cardTopSuit.datasuit = "";
            cardBottomSuit.datasuit = "";
            cardRank.datasuit = "";

        }

        if (backCardText) {
            // cardTopSuit.textContent = "♣ ♥ ♠ ♦";
            // backCardText.textContent = "Balla Games";
            backCardText.innerHTML =


                `
            <div class="logo">
    <!-- Icon -->
            <div class="logo-left-side-container">

            <div class="dots-container">
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            </div>
            <div class="dots-container">
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            </div>
            <div class="dots-container">
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            </div>
            <div class="dots-container ">
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            </div>
            <div class="dots-container">
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            
            </div>
            <div class="dots-container">
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            </div>

            <div class="dots-container ">
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            </div>

            <div class="dots-container ">
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            <div class="jb-dots"></div>
            </div>
            </div>

    <!-- Text -->
     <div class="jb-back-title">BALLA</div>
            <div class="jb-back-subtitle">GAMES</div>
    </div>
    `


            // --------------------------------

            //                 `
            //             <div class="logo">
            //     <!-- Icon -->
            //             <div class="logo-left-side-container">

            //             <div class="dots-container Ps_l_3">
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             </div>
            //             <div class="dots-container Ps_l_2">
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             </div>
            //             <div class="dots-container Ps_l_1">
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             </div>
            //             <div class="dots-container ">
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             </div>
            //             <div class="dots-container Ps_l_1">
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             </div>
            //             <div class="dots-container Ps_l_2">
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             </div>
            //             <div class="dots-container Ps_l_3">
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             <div class="jb-dots"></div>
            //             </div>

            //             </div>

            //     <!-- Text -->
            //     <div class="title">BALLA</div>
            //     <div class="subtitle">GAMES</div>
            // </div>
            //             `





            // ---------------------------------------------------
            //                 `<div class="logo">
            //                 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 104 143.5" style="enable-background:new 0 0 104 143.5;" xml:space="preserve">
            // <style type="text/css">
            // 	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
            // 	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#333333;}
            // 	.st2{fill:#CAFA20;}
            // 	.st3{fill:#FFFFFF;}
            // </style>
            // <path class="st0" d="M7.7,0.2h88.5c4.3,0,7.7,3.5,7.7,7.7v127.6c0,4.3-3.5,7.7-7.7,7.7H7.7c-4.3,0-7.7-3.5-7.7-7.7V7.9  C0,3.7,3.5,0.2,7.7,0.2z"/>
            // <path class="st1" d="M10.9,4.7h82c3.5,0,6.3,2.8,6.3,6.3v121.8c0,3.5-2.8,6.3-6.3,6.3h-82c-3.5,0-6.3-2.8-6.3-6.3V11  C4.6,7.5,7.4,4.7,10.9,4.7z"/>
            // <g>
            // 	<g>
            // 		<circle class="st2" cx="40" cy="72.7" r="2"/>
            // 		<circle class="st2" cx="42.6" cy="68" r="2"/>
            // 		<circle class="st2" cx="45.3" cy="63.4" r="2"/>
            // 		<circle class="st2" cx="48" cy="58.7" r="2"/>
            // 		<circle class="st2" cx="38" cy="65.3" r="2"/>
            // 		<circle class="st2" cx="40.6" cy="60.7" r="2"/>
            // 		<circle class="st2" cx="43.3" cy="56" r="2"/>
            // 		<circle class="st2" cx="46" cy="51.4" r="2"/>
            // 		<circle class="st2" cx="36.3" cy="58.1" r="2"/>
            // 		<circle class="st2" cx="38.9" cy="53.4" r="2"/>
            // 		<circle class="st2" cx="41.6" cy="48.8" r="2"/>
            // 		<circle class="st2" cx="44.3" cy="44.1" r="2"/>
            // 		<circle class="st2" cx="34.2" cy="50.8" r="2"/>
            // 		<circle class="st2" cx="36.8" cy="46.1" r="2"/>
            // 		<circle class="st2" cx="39.4" cy="41.5" r="2"/>
            // 		<circle class="st2" cx="42.2" cy="36.8" r="2"/>
            // 		<circle class="st2" cx="47.3" cy="70.7" r="2"/>
            // 		<circle class="st2" cx="49.9" cy="66" r="2"/>
            // 		<circle class="st2" cx="52.6" cy="61.4" r="2"/>
            // 		<circle class="st2" cx="55.3" cy="56.7" r="2"/>
            // 		<circle class="st2" cx="54.6" cy="68.7" r="2"/>
            // 		<circle class="st2" cx="57.2" cy="64.1" r="2"/>
            // 		<circle class="st2" cx="59.9" cy="59.4" r="2"/>
            // 		<circle class="st2" cx="62.6" cy="54.8" r="2"/>
            // 		<circle class="st2" cx="61.8" cy="66.7" r="2"/>
            // 		<circle class="st2" cx="64.4" cy="62.1" r="2"/>
            // 		<circle class="st2" cx="67.1" cy="57.4" r="2"/>
            // 		<circle class="st2" cx="69.8" cy="52.8" r="2"/>
            // 	</g>
            // 	<g>
            // 		<path class="st2" d="M18.4,87.4c0-0.2,0.1-0.4,0.2-0.6s0.4-0.2,0.6-0.2h7c1.7,0,3,0.5,3.8,1.5c0.5,0.5,0.7,1.2,0.7,2.1    s-0.4,1.6-1.2,2.2c1.1,0.6,1.6,1.5,1.6,2.7c0,1.2-0.4,2.2-1.3,2.8s-2,1-3.2,1h-7.4c-0.2,0-0.4-0.1-0.6-0.2    c-0.2-0.2-0.2-0.3-0.2-0.6V87.4z M21.7,91.4h4.6c0.4,0,0.6-0.1,0.9-0.3c0.2-0.2,0.3-0.5,0.3-0.9s-0.1-0.7-0.3-0.9    c-0.2-0.2-0.5-0.3-0.9-0.3h-4.6V91.4z M21.7,96.6h4.9c0.4,0,0.8-0.1,1-0.4c0.2-0.3,0.4-0.6,0.4-1.1c0-0.5-0.1-0.8-0.4-1.1    c-0.2-0.3-0.6-0.4-1-0.4h-4.9V96.6z"/>
            // 		<path class="st2" d="M31.9,98.1l2.2-8.2c0.6-2.2,2.5-3.3,5.7-3.3h4.6c0.2,0,0.4,0.1,0.5,0.2s0.2,0.3,0.2,0.6v10.7    c0,0.2-0.1,0.4-0.2,0.6s-0.4,0.2-0.6,0.2h-1.6c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.3-0.2-0.6v-2.2h-6.1l-0.6,2.2    c-0.1,0.2-0.2,0.4-0.4,0.6s-0.4,0.2-0.6,0.2h-1.7c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.1-0.2-0.1-0.3C31.9,98.3,31.9,98.2,31.9,98.1    z M36.4,93.5h5.5V89h-2.4c-0.5,0-1,0.2-1.4,0.5c-0.4,0.3-0.7,0.7-0.8,1.3L36.4,93.5z"/>
            // 		<path class="st2" d="M47.6,98.1V87.4c0-0.2,0.1-0.4,0.2-0.6s0.4-0.2,0.6-0.2H50c0.2,0,0.4,0.1,0.6,0.2s0.2,0.4,0.2,0.6v9h7.5    c0.2,0,0.4,0.1,0.6,0.2s0.2,0.4,0.2,0.6v0.8c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.3,0.2-0.6,0.2h-9.9c-0.2,0-0.4-0.1-0.6-0.2    S47.6,98.4,47.6,98.1z"/>
            // 		<path class="st2" d="M60.5,98.1V87.4c0-0.2,0.1-0.4,0.2-0.6s0.4-0.2,0.6-0.2h1.6c0.2,0,0.4,0.1,0.6,0.2s0.2,0.4,0.2,0.6v9h7.5    c0.2,0,0.4,0.1,0.6,0.2s0.2,0.4,0.2,0.6v0.8c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.3,0.2-0.6,0.2h-9.9c-0.2,0-0.4-0.1-0.6-0.2    S60.5,98.4,60.5,98.1z"/>
            // 		<path class="st2" d="M72.4,98.1l2.2-8.2c0.6-2.2,2.5-3.3,5.7-3.3h4.6c0.2,0,0.4,0.1,0.5,0.2c0.1,0.2,0.2,0.3,0.2,0.6v10.7    c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2h-1.6c-0.2,0-0.4-0.1-0.6-0.2s-0.2-0.3-0.2-0.6v-2.2h-6.1l-0.6,2.2    c-0.1,0.2-0.2,0.4-0.4,0.6s-0.4,0.2-0.6,0.2H73c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.1-0.2-0.1-0.3C72.3,98.3,72.4,98.2,72.4,98.1z     M76.9,93.5h5.5V89h-2.4c-0.5,0-1,0.2-1.4,0.5c-0.4,0.3-0.7,0.7-0.8,1.3L76.9,93.5z"/>
            // 	</g>
            // 	<g>
            // 		<path class="st3" d="M18.5,108c-0.4-0.4-0.6-1.1-0.6-2s0.2-1.5,0.7-1.9c0.4-0.4,1.1-0.6,2-0.6h0.8c0.5,0,1,0.1,1.4,0.4    s0.6,0.6,0.6,0.9c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.2,0.1h-0.4c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2-0.4-0.3-0.9-0.3h-0.6    c-0.5,0-0.9,0.1-1.1,0.3c-0.2,0.2-0.3,0.6-0.3,1.2c0,0.6,0.1,1,0.2,1.2c0.2,0.2,0.5,0.3,0.9,0.3H21c0.4,0,0.7-0.1,0.8-0.2    c0.2-0.1,0.2-0.4,0.3-0.6h-0.8c-0.1,0-0.2,0-0.2-0.1s-0.1-0.1-0.1-0.2v-0.3c0-0.1,0-0.2,0.1-0.2s0.1-0.1,0.2-0.1h1.8    c0.1,0,0.2,0,0.2,0.1s0.1,0.1,0.1,0.2v0.4c0,0.7-0.2,1.2-0.6,1.5s-1,0.5-1.8,0.5h-0.8C19.5,108.6,18.9,108.4,18.5,108z"/>
            // 		<path class="st3" d="M33.2,108.3l0.9-3.4c0.2-0.9,1-1.4,2.4-1.4h1.9c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2v4.5    c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1h-0.7c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-0.9h-2.5l-0.2,0.9    c0,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1h-0.7c-0.1,0-0.2,0-0.2-0.1c0-0.1-0.1-0.1-0.1-0.1    C33.2,108.4,33.2,108.3,33.2,108.3z M35.1,106.4h2.3v-1.9h-1c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.3-0.3,0.5L35.1,106.4z"/>
            // 		<path class="st3" d="M49.2,108.3v-4.4c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1H51c0.1,0,0.2,0,0.3,0.1    c0.1,0.1,0.1,0.1,0.2,0.2l1.1,3l1.1-3c0-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1h1.5c0.1,0,0.2,0,0.2,0.1    c0.1,0.1,0.1,0.1,0.1,0.2v4.4c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1h-0.6c-0.1,0-0.2,0-0.2-0.1s-0.1-0.1-0.1-0.2v-3.5    l-1.3,3.5c0,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1h-0.5c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2l-1.3-3.5v3.5    c0,0.1,0,0.2-0.1,0.2s-0.1,0.1-0.2,0.1h-0.6c-0.1,0-0.2,0-0.2-0.1C49.3,108.5,49.2,108.4,49.2,108.3z"/>
            // 		<path class="st3" d="M66.3,108.3v-4.4c0-0.1,0-0.2,0.1-0.2s0.1-0.1,0.2-0.1h4.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2v0.3    c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1h-3.1v1h2.7c0.1,0,0.2,0,0.2,0.1s0.1,0.1,0.1,0.2v0.3c0,0.1,0,0.2-0.1,0.2    s-0.1,0.1-0.2,0.1h-2.7v1.1h3.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2v0.3c0,0.1,0,0.2-0.1,0.2s-0.1,0.1-0.2,0.1h-4.1    c-0.1,0-0.2,0-0.2-0.1S66.3,108.4,66.3,108.3z"/>
            // 		<path class="st3" d="M80.9,107.3c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.2-0.1h0.4c0.2,0,0.4,0.1,0.5,0.3c0.1,0.2,0.4,0.3,0.8,0.3    l1.2,0c0.4,0,0.6-0.1,0.6-0.4c0-0.2-0.3-0.4-0.8-0.5c-0.2-0.1-0.5-0.1-0.8-0.2c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3-0.1-0.5-0.2-0.8-0.3    c-0.2-0.1-0.4-0.3-0.6-0.5c-0.1-0.2-0.2-0.4-0.2-0.7c0-0.5,0.2-0.8,0.5-1.1s0.9-0.4,1.8-0.4l0.9,0c0.5,0,0.9,0.1,1.3,0.4    s0.6,0.6,0.6,0.9c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.2,0.1h-0.4c-0.2,0-0.4-0.1-0.5-0.4c-0.1-0.2-0.4-0.4-0.8-0.4l-1.1,0    c-0.4,0-0.6,0.1-0.6,0.4c0,0.1,0.1,0.3,0.4,0.4c0.3,0.1,0.6,0.2,1,0.3c0.4,0.1,0.8,0.2,1.1,0.3c0.4,0.1,0.7,0.3,1,0.5    c0.3,0.2,0.4,0.5,0.4,0.9c0,0.5-0.2,0.8-0.5,1.1s-0.9,0.4-1.8,0.4l-1.1,0c-0.5,0-0.9-0.1-1.3-0.4S80.9,107.7,80.9,107.3z"/>
            // 	</g>
            // </g>
            // </svg> </div>`













            // -----------------------------------------------------------------------------

            //         `<div class="logo">
            //     <div class="icons">
            //         <span style="color: #000;">♣</span>
            //         <span style="color: red;">♥</span>
            //         <span style="color: #000;">♠</span>
            //         <span style="color: red;">♦</span>
            //     </div>
            //     <div class="pokerbackcardmaintitle">BALLA</div>
            //     <div class="subtitle">GAMES</div>
            // </div>`;
            // cardTopSuit.setAttribute("datasuit", "♣ ♥ ♠ ♦");
            // backCardText.setAttribute("datasuit", "Balla Games");

        }


    }

    const clearGameTitle = (i) => {
        // for (let i = 0; i < 5; i++) {
        const backCardText = document.getElementById(`${i}-back-card-text`);
        if (backCardText) {
            backCardText.innerHTML = "";
            backCardText.setAttribute("datasuit", "");
        }
        // }
    }

    const clickOncardToHoldorUnholdcard = () => {
        clickOncardToHoldorUnhold(id)
    }



    return (
        <>
            <li className="jacksCardContainer" style={classVaribles.liContainer} id={`jrb${id}`}>

                <div id={`${id}-back-card-text`} className="backCardImg"></div>
                <button onClick={clickOncardToHoldorUnholdcard}>
                    {/* <img id={`jrb${id}`} style={classVaribles.cardImage} src={src} /> */}


                    {/* <img id={`jrb${id}`} style={classVaribles.cardImage} src={backFaceCard.current} /> */}


                    <div  >
                        <p id={`${id}-card-rank`}></p>
                        <div id={`${id}-card-top-suit`}></div>
                        <div className="wild-text" id={`${id}-wild-joker-card-text`}></div>
                        <div id={`${id}-card-bottom-suit`}></div>

                    </div>


                </button>
                {hold && <span style={classVaribles.holdSpan}>{language.Hold}</span>}
            </li>
            <Howlersounds ref={howlerSoundsRef} mutesounds={props.mutesounds} />
        </>
    )

})


export default CardsContainer
